import { Service, computed, signal } from '@angular/core';

@Service()
export class LoadingService {
  private readonly pending = signal(0);

  readonly isLoading = computed(() => this.pending() > 0);

  show(): void {
    this.pending.update((count) => count + 1);
  }

  hide(): void {
    this.pending.update((count) => (count > 0 ? count - 1 : 0));
  }
}
